export const QC_FETCH_RECORDS = 'QC_FETCH_RECORDS'
export const QC_FETCH_RECORDS_SUCCESS = 'QC_FETCH_RECORDS_SUCCESS'
export const QC_FETCH_RECORDS_FAILURE = 'QC_FETCH_RECORDS_FAILURE'

export const QC_SCAN_VALID = 'QC_SCAN_VALID'
